"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredCard = void 0;
var tslib_1 = require("tslib");
var hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
var theme_1 = require("../theme");
var theme_palette_1 = require("../theme.palette");
var CSS = {
    container: 'c-CenteredCard',
    logo: 'c-CenteredCard__Logo',
    body: 'c-CenteredCard__Body'
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: "".concat(theme_1.DefaultTheme.space(18), " ").concat(theme_1.DefaultTheme.space(6), " ").concat(theme_1.DefaultTheme.space(6)),
        margin: '20vh auto auto',
        backgroundColor: theme_1.DefaultTheme.background.offWhite,
        borderRadius: theme_1.DefaultTheme.space(1),
        border: "1px solid rgb(".concat(theme_palette_1.ColorPaletteGrey.C300, ")"),
        minHeight: '400px',
        boxSizing: 'border-box'
    },
    _a[CSS.logo] = {
        width: '200px',
        paddingBottom: theme_1.DefaultTheme.space(12)
    },
    _a[CSS.body] = {
        width: '100%'
    },
    _a));
exports.CenteredCard = {
    view: function (children, ctx) {
        if (ctx === void 0) { ctx = {}; }
        return (0, hyperscript_1.default)('div', { className: "mdl-card ".concat(CSS.container, " ").concat(ctx.className || '') }, [
            (0, hyperscript_1.default)('img', { className: CSS.logo, src: (0, theme_1.assetPath)('/images/ike_logo_solid_dark.svg') }),
            (0, hyperscript_1.default)('div', { className: CSS.body }, children)
        ]);
    }
};
//# sourceMappingURL=centered.card.js.map